import { OktaAuth, type SigninWithRedirectOptions } from '@okta/okta-auth-js';
import { env } from '@apps/admin-portal-web/src/configs/env';

export const oktaRedirectUri = window.location.origin + '/login';

export function signInWithRedirect(nameHint: string, emailHint: string): Promise<void> {
    const oktaIssuer = env.OKTA_ISSUER;
    const oktaClientId = env.OKTA_CLIENT_ID;

    if (!oktaClientId) {
        throw new Error('okta client id not set');
    }

    if (!oktaIssuer) {
        throw new Error('okta issuer not set');
    }

    const oktaAuth = new OktaAuth({
        issuer: oktaIssuer,
        clientId: oktaClientId,
        redirectUri: oktaRedirectUri,
        responseMode: 'query',
        responseType: 'code',
        pkce: false,
        devMode: true,
    });

    const opts: SigninWithRedirectOptions = {};
    if (nameHint || emailHint) {
        opts.extraParams = {
            name_hint: nameHint,
            email_hint: emailHint,
        };
    }

    return oktaAuth.signInWithRedirect(opts);
}
